import React from 'react'
import Image from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

type ArticleCardProps = {
  title: string
  url: string
  imgUrl?: string
  source?: string
}

const ArticleCard = ({ title, url, imgUrl, source }: ArticleCardProps) => {
  return (
    <div className="bg-gray-0 rounded-lg overflow-hidden border hover:shadow-sm transition-shadow">
      {imgUrl ? (
        <Image
          alt="article-image"
          src={imgUrl}
          width={800}
          height={400}
          className="w-full h-auto object-cover"
        />
      ) : (
        <div className="h-48 bg-gradient-to-br from-blue-10 to-blue-20 flex items-center justify-center">
          <Icon
            color="informational"
            style={{ fontSize: '42px', width: 42, height: 42 }}
          >
            newspaper
          </Icon>
        </div>
      )}
      <div className="p-5 space-y-4">
        <span>
          <Text variant="body-bold">
            {title}
            {source && (
              <Text
                as="span"
                variant="body-sm"
                color="subdued"
                className="italic"
              >
                {' '}
                &mdash; {source}
              </Text>
            )}
          </Text>
        </span>
        <Button
          size="sm"
          color="white"
          onClick={() => {
            window.open(url, '_blank')?.focus()
          }}
        >
          Baca Selengkapnya
          <Icon fontSize="sm" className="ml-1">
            open_in_new
          </Icon>
        </Button>
      </div>
    </div>
  )
}

export default ArticleCard
